// The 8 demo kitchens — real photography, real client brands (Nina's & Arepas Latin Cuisine with permission).
import cafeImg from '../assets/cuisines/cafe.jpg';
import italianImg from '../assets/cuisines/italian.jpg';
import mexicanImg from '../assets/cuisines/mexican.jpg';
import sushiImg from '../assets/cuisines/sushi.jpg';
import arepasImg from '../assets/cuisines/arepas.jpg';
import argentinianImg from '../assets/cuisines/argentinian.jpg';
import milanesasImg from '../assets/cuisines/milanesas.jpg';
import grabgoImg from '../assets/cuisines/grabgo.jpg';
import sportsbarImg from '../assets/cuisines/sportsbar.jpg';

export const CUISINE_PROFILES = [
  { key: 'cafe', slug: 'cafe-luna', img: cafeImg, es: 'Café', en: 'Café' },
  { key: 'italian', slug: 'casa-mia', img: italianImg, es: 'Italiano', en: 'Italian' },
  { key: 'mexican', slug: 'el-comal', img: mexicanImg, es: 'Mexicano', en: 'Mexican' },
  { key: 'sushi', slug: 'kokoro-sushi', img: sushiImg, es: 'Sushi', en: 'Sushi' },
  { key: 'arepas', slug: 'arepas', img: arepasImg, es: 'Arepas', en: 'Arepas' },
  { key: 'argentinian', slug: 'hincha', img: argentinianImg, es: 'Argentino', en: 'Argentinian' },
  { key: 'milanesas', slug: 'chalito', img: milanesasImg, es: 'Milanesas', en: 'Milanesas' },
  { key: 'grabgo', slug: 'mila-and-go', img: grabgoImg, es: 'Aeropuerto', en: 'Airport' },
  { key: 'sportsbar', slug: 'the-rally', img: sportsbarImg, es: 'Sports Bar', en: 'Sports Bar' },
];

// The landing gate shows only the first 8 — the rest are switchable inside the demo.
export const LANDING_CUISINES = CUISINE_PROFILES.slice(0, 8);
